import React from "react";
import {BreadCrumbItem} from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import FormSection from "./FormSection";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/productos",
        label: "Productos",
        isActive: true
    },
    {
        path: "/crear",
        label: "Crear",
        isActive: true
    }
]

function CrearProducto(){
    return (
        <Page title="Registro de Producto" description="Creación de producto." breadCrumbs={breadCrumbs}>
            <FormSection />
        </Page>
    );
}

export default CrearProducto;